import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useFeatureToggles } from '@grandvisionhq/state';
import { useWishlistId } from '@grandvisionhq/svc-wishlist';
import WishlistLoader from '../../../components/WishlistLoader.js';
import { getWishlistButtonEventInfo, pushWishlistEvent } from '../../../data-layer/wishlist.js';
import { useAddToShoppingList } from '../../../hooks/use-add-to-shopping-list.js';
import { useRemoveFromShoppinglist } from '../../../hooks/use-remove-from-shopping-list.js';
import { useWishlistAuthState } from '../../../hooks/use-wishlist-auth-state.js';
import AnonymousWishlistButton from './AnonymousWishlistButton.js';
import UserWishlistButton from './UserWishlistButton.js';

const WishlistButtonContainer = ({ sku , productLocation , tabIndex  })=>{
    const { localWishlist , clearWishlist  } = useWishlistId();
    const { isAuthLoading , isUserLoggedIn  } = useWishlistAuthState();
    const handlePushWishlistEvent = (messageType, interactionType, siteFeature)=>{
        pushWishlistEvent({
            siteFeature,
            interactionType,
            messageType,
            item: {
                sku
            }
        });
    };
    const { addToShoppinglist  } = useAddToShoppingList({
        isLoggedIn: isUserLoggedIn,
        onCompleted: (data)=>{
            // If the mutation "succeeds", the BE can technically still send back a failure in the response
            // and a 200. This is why we need to check if the shoppinglist is actually there.
            // In case of a failure the shoppinglist will be null.
            if (data.addToShoppinglist.__typename === 'AddToShoppinglistSuccessResponse') {
                toast.success('account.wishlist.add.success');
                const { interactionType , siteFeature  } = getWishlistButtonEventInfo('add', productLocation);
                handlePushWishlistEvent('item_added', interactionType, siteFeature);
            }
        },
        onError: ()=>{
            toast.failed('account.wishlist.add.error');
            const { interactionType , siteFeature  } = getWishlistButtonEventInfo('add', productLocation);
            handlePushWishlistEvent('error', interactionType, siteFeature);
        }
    });
    const { removeFromShoppinglist , loading: isUpdateLoading  } = useRemoveFromShoppinglist({
        onCompleted: (data)=>{
            var ref;
            // If the mutation "succeeds", the BE can technically still send back a failure in the response
            // and a 200. This is why we need to check if the shoppinglist is actually there.
            // In case of a failure the shoppinglist will be null.
            if (data.removeFromShoppinglist.__typename == 'RemoveFromShoppinglistSuccessResponse') {
                toast.success('account.wishlist.remove.success');
                const { interactionType , siteFeature  } = getWishlistButtonEventInfo('remove', productLocation);
                handlePushWishlistEvent('item_removed', interactionType, siteFeature);
            }
            /*
        If the wishlist is empty after removing an item (i.e. mutating the list),
        we need to remove the list from local storage to prevent modifying an empty
        list with the same id.
      */ if (data.removeFromShoppinglist.__typename === 'RemoveFromShoppinglistSuccessResponse' && !((ref = data.removeFromShoppinglist.result) === null || ref === void 0 ? void 0 : ref.items.length)) {
                clearWishlist();
            }
        },
        onError: ()=>{
            toast.failed('account.wishlist.remove.error');
            const { interactionType , siteFeature  } = getWishlistButtonEventInfo('remove', productLocation);
            handlePushWishlistEvent('error', interactionType, siteFeature);
        }
    });
    const onWishlistClick = (action, wishlistId, event)=>{
        // On the PLP the wishlist button is wrapped in a link, so we need to prevent the default
        // behavior of the link to prevent navigation when clicking the button.
        event === null || event === void 0 ? void 0 : event.preventDefault();
        if (action === 'add') {
            addToShoppinglist([
                sku
            ], wishlistId).catch((error)=>console.log(error)
            );
        } else {
            removeFromShoppinglist([
                sku
            ], wishlistId).catch((error)=>console.log(error)
            );
        }
    };
    if (isAuthLoading) {
        return /*#__PURE__*/ React.createElement(WishlistLoader, {
            className: "wishlist-loader__skeleton--button"
        });
    }
    return !isAuthLoading && isUserLoggedIn ? /*#__PURE__*/ React.createElement(UserWishlistButton, {
        sku: sku,
        disabled: isAuthLoading || isUpdateLoading,
        isUpdateLoading: isUpdateLoading,
        onWishlistClick: onWishlistClick,
        tabIndex: tabIndex
    }) : /*#__PURE__*/ React.createElement(AnonymousWishlistButton, {
        sku: sku,
        disabled: isAuthLoading || isUpdateLoading,
        isUpdateLoading: isUpdateLoading,
        onWishlistClick: onWishlistClick,
        localWishlistId: localWishlist === null || localWishlist === void 0 ? void 0 : localWishlist.id,
        tabIndex: tabIndex
    });
};
const ConditionalButtonWrapper = (props)=>{
    const { isWishlistEnabled  } = useFeatureToggles();
    if (isWishlistEnabled) {
        return /*#__PURE__*/ React.createElement(WishlistButtonContainer, swcHelpers.extends({}, props));
    }
    return null;
};

export { ConditionalButtonWrapper as default };
//# sourceMappingURL=WishlistButtonContainer.js.map
